import React, { useContext } from 'react';

import { PageStateContext } from '../../context/PageStateContext';

import DraftCategoryFolderSelector from './DraftCategoryFolderSelector';
import DraftPeople from './DraftPeople';
import DraftPublish from './DraftPublish';
import RequestDraftEditApproval from './RequestDraftEditApproval';
import DraftDropdown from './DraftDropdown';
import DraftClose from './DraftClose';

const DraftHeader = (props) => {
    const { pageState } = useContext(PageStateContext);
    if (!pageState) return null;
    const { isSuggestEdit } = pageState;
    const extraClass = (pageState && pageState.isTemplateDraft) ? 'tempate-draft' : '';
    return (
        <div className={`page-top flex-none ${extraClass}`}>
            <div className="flex-auto flex gray">
                <DraftCategoryFolderSelector />
            </div>
            <p id="save-status" className="save-status" />
            { !isSuggestEdit && <DraftPeople /> }
            <div className="flex-none no-select">
                { !isSuggestEdit && <DraftDropdown /> }
                { isSuggestEdit ? <RequestDraftEditApproval /> : <DraftPublish /> }
                <DraftClose isSuggestEdit={isSuggestEdit} />
            </div>
        </div>
    );
};

export default DraftHeader;
